<template>
  <div>
    <o-section :overlay="true">
      <o-text-input type="search" placeholder="Zoeken" icon="search" />
    </o-section>
    <o-section :overlay="true">
      <o-list-item
        :label="location"
        :no-padding="true"
        v-for="location in locations"
        :key="`stand${location}`"
      />
    </o-section>
  </div>
</template>

<script>
import OListItem from '@/components/base/OListItem.vue'
import OTextInput from '@/components/base/OTextInput.vue'
export default {
  name: 'OEditStand',
  components: { OTextInput, OListItem },
  data: () => ({
    locations: [
      'Ajuinlei',
      'Belfortstraat',
      'Gent-Dampoort',
      'Schoolkaai',
      'Sint-Jacbosmarkt',
      'Spaans Kasteel'
    ]
  })
}
</script>
